import { createSlice } from "@reduxjs/toolkit"

// Do not hydrate from localStorage "sirenSchedule" here — that key stores only the siren event array,
// not a school document, and breaks the shape expected as schooldetails (see siren.js for optional local cache).

const Insider = createSlice({
    name: "todos",
    initialState: [],
    reducers: {
        schooldetails: (state, action) => {
            // Handle both action.payload.data and action.payload directly
            const newData = action.payload?.data || action.payload || [];
            
            // Ensure it's always an array
            const result = Array.isArray(newData) ? newData : [newData];
            
            // Ensure terms is always an array for each school
            const normalized = result.map(school => {
                if (school && typeof school === 'object') {
                    // Create a new object to avoid mutation
                    const normalizedSchool = { ...school };
                    let normalizedTerms = [];
                    
                    if (!school.terms) {
                        normalizedTerms = [];
                    } else if (typeof school.terms === 'string') {
                        // If terms is a string, convert to array
                        try {
                            const parsed = JSON.parse(school.terms);
                            normalizedTerms = Array.isArray(parsed) ? parsed : [school.terms];
                        } catch (e) {
                            normalizedTerms = school.terms.includes(',') 
                                ? school.terms.split(',').map(t => t.trim()).filter(t => t.length > 0)
                                : [school.terms];
                        }
                    } else if (Array.isArray(school.terms)) {
                        // If terms is already an array, normalize each item
                        normalizedTerms = school.terms.map(term => {
                            // If term is an object, extract the name or convert to string
                            if (typeof term === 'object' && term !== null) {
                                // Check if it has a name property (Liberia format)
                                if (term.name) {
                                    return term.name;
                                }
                                // Otherwise, try to stringify or use a default
                                return String(term);
                            }
                            // If it's already a string, return as is
                            return typeof term === 'string' ? term : String(term);
                        }).filter(term => term && term.trim() !== ''); // Filter out empty strings
                    } else {
                        // If it's neither string nor array, make it an array
                        normalizedTerms = [];
                    }
                    
                    normalizedSchool.terms = normalizedTerms;
                    return normalizedSchool;
                }
                return school;
            });
            
            return normalized;

            // localStorage.setItem("sirenSchedule",JSON.stringify([]))

        }

    },

})

export const { schooldetails } = Insider.actions;
export default Insider.reducer;